/**
 * <LanguageSwitcher> — ghost-button locale toggle for auth screens.
 *
 * Calls `i18n.changeLanguage(target)` from react-i18next; the
 * `attachDirectionDriver` wired up in `@linkhr/i18n/initI18n` already listens
 * for `languageChanged` and flips `<html dir>` + body font class — no
 * manual DOM writes here.
 *
 * Label is the OTHER locale's own name ("العربية" when in English, "English"
 * when in Arabic) so users can always read the switcher regardless of current
 * language.
 */
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@linkhr/design-system";

export function LanguageSwitcher(): JSX.Element {
  const { i18n, t } = useTranslation("auth");
  const current = i18n.resolvedLanguage ?? "en";
  const target = current === "ar" ? "en" : "ar";
  const label = target === "ar" ? t("lang.switch_to_arabic") : t("lang.switch_to_english");

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={() => {
        void i18n.changeLanguage(target);
      }}
    >
      {label}
    </Button>
  );
}
